/** Formatação pt-BR usada nas telas (datas, valores do log, rótulos). */
export function dataHora(v: string | Date | null | undefined): string {
  if (!v) return '—';
  return new Date(v).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}

export function data(v: string | null | undefined): string {
  if (!v) return '—';
  const [a, m, d] = v.slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
}

/** Valor de log_auditoria (jsonb) exibido de forma legível. */
export function valorLog(v: unknown): string {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'boolean') return v ? 'sim' : 'não';
  if (typeof v === 'string') return v;
  return JSON.stringify(v);
}

export const ROTULO_ACAO: Record<string, string> = {
  criar: 'Criação',
  editar: 'Edição',
  inativar: 'Inativação',
  reativar: 'Reativação',
  conceder: 'Permissão concedida',
  revogar: 'Permissão revogada',
  habilitar_mfa: 'MFA habilitado',
  redefinir_mfa: 'MFA redefinido',
  redefinir_senha: 'Senha redefinida',
  alterar_senha: 'Senha alterada',
  desbloquear: 'Desbloqueio',
  encerrar_vigencia: 'Vigência encerrada',
  adicionar_entidade: 'Matriz/filial adicionada',
  editar_entidade: 'Matriz/filial editada',
  definir_principal: 'Entidade principal alterada',
  transferir_entidade: 'Entidade transferida entre Clientes',
  corrigir_encerrada: 'Oportunidade encerrada corrigida',
  enviar_documento_cliente: 'Documento do Cliente enviado',
  inativar_documento_cliente: 'Documento do Cliente inativado',
  enviar_documento_oportunidade: 'Documento da Oportunidade enviado',
  inativar_documento_oportunidade: 'Documento da Oportunidade inativado',
  alterar_comissao: 'Comissão padrão alterada',
  importar: 'Importação (.xlsx)',
  registrar_vigencia: 'Nova vigência registrada',
  importar_previa: 'Prévia de importação',
  importar_concluir: 'Importação concluída',
  importar_descartar: 'Importação descartada',
  mover_estagio: 'Estágio alterado',
  registrar_resultado: 'Resultado registrado',
  adicionar_registro: 'Registro da Oportunidade adicionado',
  renovar_registro: 'Registro renovado',
  substituir_registro: 'Novo número de registro',
  editar_registro: 'Registro editado',
  encerrar_registro: 'Registro encerrado',
  reabrir_registro: 'Registro reaberto',
  registrar_atividade: 'Atividade registrada',
  concluir_tarefa: 'Tarefa concluída',
  salvar_rascunho: 'Rascunho da Proposta salvo',
  enviar_versao: 'Versão da Proposta enviada',
  nova_versao: 'Nova versão da Proposta',
  registrar_resultado_linhas: 'Resultado por linha registrado',
  aceitar_versao: 'Versão aceita',
  recusar_versao: 'Versão recusada (Perdida)',
  editar_ptax: 'PTAX editada',
  alterar_regra_comissao: 'Comissão alterada (Proposta)',
  confirmar_dados_bancarios: 'Dados bancários confirmados (Trade-in)',
  registrar_empresa: 'Dados da Inttrix nos documentos registrados',
  gerar_pedido: 'Pedido gerado',
  vincular_oc: 'OC do Cliente vinculada',
  substituir_oc: 'OC do Cliente substituída',
  gerar_ordens: 'Ordens geradas (OCF)',
  gerar_documento_operacional: 'Documento operacional gerado (OL/OTI)',
  complementar_ordem: 'Dados operacionais da Ordem complementados',
  emitir_ordem: 'Ordem emitida e enviada',
  confirmar_ordem: 'Ordem confirmada',
  registrar_faturamento: 'Faturamento registrado',
  estornar_faturamento: 'Faturamento estornado',
  cancelar_ordem: 'Ordem cancelada (saldo)',
  criar_substituta: 'Ordem substituta criada',
  emitir_documento_operacional: 'Documento operacional emitido',
  cancelar_documento_operacional: 'Documento operacional cancelado',
  enviar_lixeira: 'Enviado à Lixeira',
  restaurar_lixeira: 'Restaurado da Lixeira',
  migracao_numeracao: 'Migração: numeração legada',
  migracao_importar: 'Migração: registro importado',
};

export const ROTULO_EVENTO_ACESSO: Record<string, string> = {
  login_sucesso: 'Login',
  login_primeiro_fator: 'Primeiro fator no Microsoft 365 (aguardando MFA do HUB)',
  login_falha: 'Falha de login',
  login_bloqueado: 'Acesso bloqueado',
  mfa_falha: 'Falha de MFA',
  mfa_cadastro_iniciado: 'Cadastro de MFA iniciado',
  logout: 'Logout',
  sessao_expirada: 'Sessão expirada',
  sessao_revogada: 'Sessões revogadas',
  acesso_negado: 'Acesso negado',
  exportacao: 'Exportação',
  // CP13b — eventos OBSERVADOS no provedor de identidade (não são ações do HUB)
  provedor_login_sucesso: 'Login no provedor',
  provedor_login_falha: 'Falha de login no provedor',
  provedor_logout: 'Saída no provedor',
  provedor_logout_falha: 'Falha de saída no provedor',
  provedor_ip_bloqueado: 'IP bloqueado pela proteção do provedor',
  provedor_usuario_temporariamente_bloqueado: 'Usuário temporariamente impedido pelo provedor',
  provedor_protecao_tentativas_liberada: 'Proteção contra tentativas liberada no provedor',
  provedor_mfa_sucesso: 'MFA confirmado no provedor',
  provedor_mfa_falha: 'Falha de MFA no provedor',
  provedor_mfa_recusado: 'MFA recusado pelo usuário no provedor',
  provedor_mfa_cadastrado: 'MFA cadastrado no provedor',
  provedor_mfa_tentativas_excedidas: 'Tentativas de MFA excedidas no provedor',
  provedor_mfa_recuperacao: 'Código de recuperação de MFA usado',
  provedor_mfa_recuperacao_falha: 'Código de recuperação de MFA inválido',
  provedor_mfa_removido: 'Fator de MFA removido no provedor',
  provedor_senha_alterada: 'Senha alterada no provedor',
  provedor_senha_alteracao_falha: 'Falha ao alterar senha no provedor',
  provedor_senha_redefinicao_solicitada: 'Redefinição de senha solicitada no provedor',
  provedor_senha_redefinicao_falha: 'Falha ao solicitar redefinição de senha',
  provedor_senha_vazada: 'Tentativa com senha vazada detectada pelo provedor',
  provedor_email_verificado: 'E-mail verificado no provedor',
  provedor_verificacao_email_solicitada: 'Verificação de e-mail solicitada no provedor',
  provedor_email_alterado: 'E-mail alterado no provedor',
  provedor_email_alteracao_falha: 'Falha ao alterar e-mail no provedor',
  provedor_cadastro: 'Cadastro feito diretamente no provedor',
  provedor_usuario_excluido: 'Identidade excluída no provedor',
  provedor_exclusao_falha: 'Falha ao excluir identidade no provedor',
  provedor_operacao_administrativa: 'Operação administrativa no provedor',
  provedor_configuracao_mfa_alterada: 'Configuração de MFA do provedor alterada',
  provedor_lacuna_eventos: 'Lacuna na importação de eventos do provedor',
};

export function agruparSegredo(s: string): string {
  return s.replace(/(.{4})/g, '$1 ').trim();
}
